


























































































































































import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { number } from '@coders-tm/vue-number-format';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import DNumberbox from "@/components/DNumberbox/numberbox.vue";
import choicePopup from "@/components/InputComponents/choice-popup.vue";

import { UserPreset, UniversalData } from "@/services/models-service";
import { tariffWarmEnergy, tariffWarmPower } from "@/constants";
import { periods } from "@/constants";
import { format2DigitsVariant } from "@/utils/numbers";
import PresetService from '@/services/user_preset_service';
import NumberSpan from '@/components/InputComponents/number-span.vue';

@Component({
  name: 'AggregatedRow',
  components: {
    number,
    DNumberbox,
    choicePopup,
    NumberSpan
  }
})
export default class  extends Vue {
  @PropSync('presets') public localPresets!: UserPreset;
  @PropSync('portion') public saleData!: any;
  @PropSync('secondaryPortion') public secondaryBlock!: any[];
  @Prop() public periodName!: string;
  @Prop() public blockId!: string;
  @Prop() public tariffs!: { [key: string]:  any; };
  @Prop() public secondaryTariffs!: { [key: string]:  any; };
  @Prop() public blockAccept!: any;
  @Prop({default: false}) public editingVolume!: boolean;
  @Prop({default: false}) public editingRows!: boolean;
  // показ доп срезки не обновляется "на лету" в зависимости от данных localPresets, а только после нажатия "Загрузить"
  @Prop({default: false}) public showSecondaryCut!: boolean;
  @Prop({default: false}) public showPowerColumns!: boolean;

  public options: any[] = [];
  public months = periods;
  public tariffWarmEnergy: any = tariffWarmEnergy;
  public tariffWarmPower: any = tariffWarmPower;

  public initiated: boolean = false;
  public isRowMoving: boolean = false;

  public choicePopup: any = {
    visible: false,
    te: false,
    power: false,
    tariff: 1,
    volume: false,
    cost: false,
    block: ''
  }

  public focusIndex: null | number = null;

  public currentData: UniversalData | null = null;

  get cssVars() {
    return {
      '--width': PresetService.tableWidth + 'px'
    }
  }


  get tarifReadOnly() {
    if(this.blockAccept && this.blockAccept.tarif) {
      return true;
    } else {
      return false;
    }
  }

  get volumeReadOnly() {
    if(this.blockAccept && this.blockAccept.volume) {
      return true;
    } else {
      return false;
    }
  }

  get costReadOnly() {
    if(this.volumeReadOnly && this.tarifReadOnly) {
      return true;
    } else {
      return false;
    }
  }

  async mounted() {
    this.options = [
        { text: 'Удалить' },
      ];
    this.initiated = true;
    this.choicePopup.block = this.blockId;

    this.$root.$on('row-moving-start', () => {
      this.isRowMoving = true;
    });
    this.$root.$on('row-moving-end', () => {
      this.isRowMoving = false;
    });
  }

  beforeDestroy() {
    // Отписываемся от событий
    this.$root.$off('row-moving-start');
    this.$root.$off('row-moving-end');
  }


  findSameSecondaryRow(mainData: any, secondaryData: any, blockName: string) {
    console.log("maindata", mainData)
    console.log('sec', secondaryData)
    console.log('block', blockName)
    console.log('saledata', this.saleData)
    const contractor_instance_id = mainData.contractor_instance_id
    const tariff_instance_id = mainData.tariff_instance_id
    let result = secondaryData.find((i: any) => {
      return (i.contractor_instance_id === contractor_instance_id && i.tariff_instance_id === tariff_instance_id)
    })
    console.log(result)
    if(result && result[blockName]) {
      return result[blockName]
    } else {
      return 0
    }
  }

  getSecondaryTarrifIdByMain(data: any, secData: any, type: any){
    const instanceIdTariff = data.tariff_instance_id
    const result = secData.find((i: any) => {
      return i.tariff_instance_id === instanceIdTariff
    })
    if (result && result.id_tarif){
      return this.secondaryTariffs[result.id_tarif][type]
    } else {
      return 0
    }
  }

  getMatchesRows(secondaryData: any) {
    return this.saleData.some((i: any) => {
      return secondaryData.contractor_instance_id === i.contractor_instance_id && secondaryData.tariff_instance_id === i.tariff_instance_id
    })
  }

  changeVolPower(data: UniversalData) {
    const tarif = this.tariffs[data.id_tarif];
    if (data.cost_power === 0) {
      data.cost_power = data.vol_power * tarif[this.tariffWarmPower[this.periodName]];
      data.cost_delta_power = 0;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      this.currentData = data;
      this.choicePopup.tariff = tarif[this.tariffWarmPower[this.periodName]];
      this.choicePopup.power = true;
      this.choicePopup.volume = true;
      this.choicePopup.visible = true;
    }
  }

  changeCostPower(data: any) {
    const tarif = this.tariffs[data.id_tarif];
    if (this.volumeReadOnly && !this.isRowMoving) {
      alert('Нельзя менять стоимость при акцептированом объеме', 'Ошибка');
      data.cost_power = tarif[this.tariffWarmPower[this.periodName]] * data.vol_power;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      if (tarif[this.tariffWarmPower[this.periodName]] < 0 || tarif[this.tariffWarmPower[this.periodName]] === 0) {
        data.cost_power = 0;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        this.currentData = data;
        this.choicePopup.tariff = tarif[this.tariffWarmPower[this.periodName]];
        this.choicePopup.power = true;
        this.choicePopup.cost = true;
        this.choicePopup.visible = true;
      }
    }
  }

  changeVolTe(data: UniversalData) {
    const tarif = this.tariffs[data.id_tarif];
    if (data.cost_te === 0) {
      data.cost_te = data.vol_te * tarif[this.tariffWarmEnergy[this.periodName]];
      data.cost_delta_te = 0;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      this.currentData = data;
      this.choicePopup.tariff = tarif[this.tariffWarmEnergy[this.periodName]];
      this.choicePopup.te = true;
      this.choicePopup.volume = true;
      this.choicePopup.visible = true;
    }
  }

  changeCostTe(data: UniversalData) {
    const tarif = this.tariffs[data.id_tarif];
    if (this.volumeReadOnly && !this.isRowMoving) {
      alert('Нельзя менять стоимость при акцептированом объеме', 'Ошибка');
      data.cost_te = tarif[this.tariffWarmEnergy[this.periodName]] * data.vol_te;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      if (tarif[this.tariffWarmEnergy[this.periodName]] < 0 || tarif[this.tariffWarmEnergy[this.periodName]] === 0) {
        data.cost_te = 0;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        this.currentData = data;
        this.choicePopup.tariff = tarif[this.tariffWarmEnergy[this.periodName]];
        this.choicePopup.te = true;
        this.choicePopup.cost = true;
        this.choicePopup.visible = true;
      }
    }
  }



  focusInNumberBox(rowIndex: number, e: any) {
    this.focusIndex = rowIndex;
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    Vue.nextTick(() => {
      inputEl.selectionStart = 0;
      inputEl.selectionEnd = inputEl.value.length;
    })
  }

  focusOutNumberBox(rowIndex: number) {
    this.focusIndex = null;
  }

  correctFormat(e:any) {
  let inputEl = e.element.querySelector(".dx-texteditor-input");
  inputEl.addEventListener('paste', (event:any) => {
    event.preventDefault();
    //@ts-ignore
    let paste = (event.clipboardData || window.clipboardData).getData('text');
    paste = paste.replace(".", ",");
    inputEl.value = paste;
  })
}

  get route() {
    return this.$route.name
  }

  // region Флаги отображения столбцов таблицы
  get show_volume() {
    if((this.localPresets.losses_show_volume && this.route === 'losses')  || (this.localPresets.buy_show_volume && this.route === 'buy') ||
    (this.localPresets.sale_show_volume && this.route === 'sale') || (this.localPresets.transport_cost_show_volume && this.route === 'transport_cost') ||
    (this.localPresets.transport_gain_show_volume && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost() {
    if((this.localPresets.buy_show_cost && this.route === 'buy') || (this.localPresets.sale_show_cost && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost_delta() {
    if((this.localPresets.buy_show_cost_delta && this.route === 'buy') || (this.localPresets.sale_show_cost_delta && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_delta && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_delta && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price() {
    if((this.localPresets.buy_show_price && this.route === 'buy') || (this.localPresets.sale_show_price && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  // endregion Флаги отображения столбцов таблицы

  get columnsValueList() {
    return [
      { name: 'vol_te', visible: this.show_volume },
      { name: 'price_te', visible: this.show_price },
      { name: 'cost_te', visible: this.show_cost },
      { name: 'cost_delta_te', visible: this.show_cost_delta },
      { name: 'vol_power', visible: this.show_volume && this.showPowerColumns },
      { name: 'price_power', visible: this.show_price && this.showPowerColumns },
      { name: 'cost_power', visible: this.show_cost && this.showPowerColumns },
      { name: 'cost_delta_power', visible: this.show_cost_delta && this.showPowerColumns },
      { name: 'price_total', visible: this.show_price && this.showPowerColumns },
      { name: 'cost_total', visible: this.show_cost && this.showPowerColumns },
    ]
  }



  formatReadOnlyValue(val: number) {
    return this.$options.filters?.numberFormat(val, 2) || format2DigitsVariant.format(val);
  }

  changeFormat(data:any) {
    return this.$options.filters?.numberFormat(data, 2) || this.$options.filters?.numberFormat(data, 0);
  }

  // Расчет значения "Цена/Тариф с учетом мощности (итого)"
  private calcPriceTotal(data: any) {
    return (data.cost_total + data.cost_delta_te + data.cost_delta_power) / (data.vol_te + data.vol_power) ? (data.cost_total + data.cost_delta_te + data.cost_delta_power) / (data.vol_te + data.vol_power / 1000) : 0
  }

}
